// fireworks.js (minimized)
(function(global) {
  // --- Fireworks Module ---
  function Fireworks(config = {}) {
    let canvas, ctx;
    let rockets = [];
    let particles = [];
    let particlePool = [];
    let startTime = null;
    let animationFrameId;
    const stopAfterMs = config.stopAfterSeconds ? config.stopAfterSeconds * 1000 : null;
    let launched = false;

    // user-definable parameters
    const shellCount = config.initialCount || 600;
    const spawnRate = config.spawnRate || 0.1;
    const maxParticles = config.maxParticles || 2000;
    const particleTrailMax = config.particleTrailMax || 8;
    const explosionColorCount = config.explosionColorCount || 2;
    const minExplosionParticles = config.minExplosionParticles || 500;

    // cache Math functions
    const _random = (min, max) => Math.random() * (max - min) + min;
    const _cos = Math.cos, _sin = Math.sin;

    // Precompute explosion coordinates
    const shellMaxR = config.shellMaxRadius || 100;
    const shellJitter = config.shellRadiusJitter || 80;
    const cx = shellMaxR, cy = shellMaxR;
    const shellCoords = new Array(shellCount);

    for (let i = 0; i < shellCount; i++) {
      const ang = Math.random() * 2 * Math.PI;
      let r = Math.sqrt(Math.random()) * shellMaxR + _random(-shellJitter, shellJitter);
      r = Math.max(0, Math.min(r, shellMaxR));
      shellCoords[i] = {
        x: cx + _cos(ang) * r,
        y: cy + _sin(ang) * r,
        dx: _cos(ang),
        dy: _sin(ang),
        norm: r / shellMaxR
      };
    }

    class Particle {
      constructor() { this.reset(); }
      reset(x, y, vx, vy, hue, size) {
        this.x = x; this.y = y;
        this.vx = vx; this.vy = vy;
        this.gravity = config.gravity || 0.06;
        this.friction = config.friction || 0.80;
        this.alpha = 1;
        this.decay = _random(config.decayMin || 0.01, config.decayMax || 0.06);
        this.size = size;
        this.hue = hue;
        // trail for individual particles
        this.trail = [];
      }
      update(i) {
        // record position before physics
        this.trail.unshift({ x: this.x, y: this.y, alpha: this.alpha });
        if (this.trail.length > particleTrailMax) this.trail.pop();
        // apply physics
        this.vx *= this.friction;
        this.vy = this.vy * this.friction + this.gravity;
        this.x += this.vx;
        this.y += this.vy;
        this.alpha -= this.decay;
        if (this.alpha <= 0) {
          particlePool.push(particles[i]);
          particles[i] = particles[particles.length - 1];
          particles.pop();
        }
      }
      draw() {
        ctx.save();
        ctx.globalCompositeOperation = 'lighter';
        // draw particle trail segments
        for (let j = 1; j < this.trail.length; j++) {
          const p0 = this.trail[j - 1];
          const p1 = this.trail[j];
          ctx.globalAlpha = p1.alpha * 0.5;
          ctx.lineWidth = this.size;
          ctx.beginPath();
          ctx.moveTo(p0.x, p0.y);
          ctx.lineTo(p1.x, p1.y);
          ctx.strokeStyle = `hsl(${this.hue},100%,60%)`;
          ctx.stroke();
        }
        // draw main particle
        ctx.globalAlpha = this.alpha;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, 2 * Math.PI);
        ctx.fillStyle = `hsl(${this.hue},100%,60%)`;
        ctx.fill();
        // sparkle overlay
        if (Math.random() < 0.2) {
          ctx.strokeStyle = `hsl(${this.hue},100%,80%)`;
          ctx.lineWidth = Math.max(1, this.size * 0.5);
          ctx.beginPath();
          ctx.moveTo(this.x - this.size, this.y);
          ctx.lineTo(this.x + this.size, this.y);
          ctx.moveTo(this.x, this.y - this.size);
          ctx.lineTo(this.x, this.y + this.size);
          ctx.stroke();
        }
        ctx.restore();
      }
    }

    class Firework {
      constructor(sx, sy, ty) {
        this.startX = sx; this.startY = sy;
        this.x = sx; this.y = sy;
        this.targetY = ty;
        this.vy = -_random(config.launchMin || 5, config.launchMax || 18);
        this.spiralR = _random(0.3, 0.7);
        this.spiralT = _random(40, 80) * 2 * Math.PI;
        this.hue = Math.random() * 360;
        this.trail = [];
        this.trailMax = config.trailMax || 30;
        this.hues = [this.hue, ...Array.from({ length: explosionColorCount - 1 }, () => Math.random() * 360)];
      }
      update(i) {
        // ember trail
        this.spawnParticle(this.x, this.y, _random(-0.6, 0.6), _random(0.6, 2), this.hue, _random(0.8, 1));
        // move
        this.y += this.vy;
        this.vy += config.gravityPull || 0.15;
        // spiral path
        const t = Math.min(Math.max((this.startY - this.y) / (this.startY - this.targetY), 0), 1);
        const ang = t * this.spiralT;
        this.x = this.startX + _cos(ang) * this.spiralR;
        // record trail
        this.trail.unshift({ x: this.x, y: this.y });
        if (this.trail.length > this.trailMax) this.trail.pop();
        // explode
        if (this.y <= this.targetY || this.vy >= 0) this._explode(i);
      }
      _explode(i) {
        let count = 0;
        for (let pt of shellCoords) {
          if (particles.length >= maxParticles) break;

          const hue = this.hues[Math.floor(Math.random() * this.hues.length)];
          const speed = pt.norm * _random(config.explosionMin || 4, config.explosionMax || 7);

          this.spawnParticle(
            this.x + pt.x - cx,
            this.y + pt.y - cy,
            pt.dx * speed,
            pt.dy * speed,
            hue,
            (_random(0.8, 1) * (1 - pt.norm) + _random(2, 4) * pt.norm)
          );
          count++;
        }

        // Ensure we reach the minimum
        while (count < minExplosionParticles && particles.length < maxParticles) {
          const ang = Math.random() * 2 * Math.PI;
          const r = Math.random();
          const dx = Math.cos(ang), dy = Math.sin(ang);
          const speed = r * _random(config.explosionMin || 4, config.explosionMax || 7);

          const hue = this.hues[Math.floor(Math.random() * this.hues.length)];
          this.spawnParticle(
            this.x + dx * shellMaxR * r,
            this.y + dy * shellMaxR * r,
            dx * speed,
            dy * speed,
            hue,
            _random(0.8, 2)
          );
          count++;
        }

        rockets[i] = rockets[rockets.length - 1];
        rockets.pop();
      }
      spawnParticle(x, y, vx, vy, hue, size) {
        let p = particlePool.length ? particlePool.pop() : new Particle();
        p.reset(x, y, vx, vy, hue, size);
        if (particles.length < maxParticles) particles.push(p);
      }
      draw() {
        ctx.save();
        ctx.globalCompositeOperation = 'lighter';
        // firework trail
        for (let i = 1, len = this.trail.length; i < len; i++) {
          const p0 = this.trail[i - 1], p1 = this.trail[i];
          const f = i / len;
          ctx.globalAlpha = (1 - f) * (1 - f);
          ctx.lineWidth = (config.trailWidthMax || 6) * (1 - f) + 0.5;
          ctx.beginPath();
          ctx.moveTo(p0.x, p0.y);
          ctx.lineTo(p1.x, p1.y);
          ctx.strokeStyle = `hsl(${this.hue},100%,70%)`;
          ctx.stroke();
        }
        ctx.restore();
      }
    }

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    function animate(ts) {
      if (!startTime) startTime = ts;
      const elapsed = ts - startTime;

      const shouldStopSpawning = stopAfterMs && elapsed >= stopAfterMs;
      const activeRockets = rockets.length > 0;
      const activeParticles = particles.length > 0;

      // Continue rendering if anything is still active
      if (!shouldStopSpawning || activeRockets || activeParticles) {
        animationFrameId = requestAnimationFrame(animate);
      } else {
        cleanup();
        return;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Prevent new rockets after stop time
      if (!shouldStopSpawning && Math.random() < spawnRate) {
        rockets.push(
          new Firework(
            _random(50, canvas.width - 50),
            canvas.height,
            _random(canvas.height * 0.2, canvas.height * 0.5)
          )
        );
      }

      // Update and draw everything
      for (let i = rockets.length - 1; i >= 0; i--) rockets[i].update(i);
      for (let i = particles.length - 1; i >= 0; i--) particles[i].update(i);
      rockets.forEach(r => r.draw());
      particles.forEach(p => p.draw());
    }

    function trigger(container = document.body) {
      canvas = document.getElementById('fireworksCanvas') || document.createElement('canvas');
      if (!canvas.parentNode) container.appendChild(canvas);
      canvas.id = 'fireworksCanvas';
      ctx = canvas.getContext('2d');
      Object.assign(canvas.style, {
        position: 'fixed',
        top: '0', left: '0',
        width: '100vw', height: '100vh',
        pointerEvents: 'none', zIndex: '99999999', background: 'transparent'
      });
      resize();
      window.addEventListener('resize', resize);
      animationFrameId = requestAnimationFrame(animate);
    }
    function cleanup() {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resize);
      if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
      rockets = [];
      particles = [];
      particlePool = [];
    }

    return { trigger, cleanup };
  }
  global.Fireworks = Fireworks;
})(window);

// Usage:
// const fw = Fireworks({ stopAfterSeconds:100, initialCount:25, spawnRate:0.10, maxParticles:700, particleTrailMax:10, minExplosionParticles: 600 });
// fw.trigger();
